<template>
  <div class="monitoring-page">
    <v-card class="text-right" flat tile height="25">
      <v-btn x-small icon @click="close()">
        <v-icon x-small>
          mdi-close
        </v-icon>
      </v-btn>
    </v-card>
    <v-card class="text-right caption" flat tile height="25">
      基準時刻 : {{ currentDateTime }}
    </v-card>

    <!-- 雨量 -->
    <v-card tile flat height="35">
      <v-chip small>
        <v-switch dense v-model="visiblity.rain"></v-switch>
        雨量モニタリング
      </v-chip>
    </v-card>
    <v-data-table
      v-if="visiblity.rain"
      :height="tableHeight.rain"
      class="rain-table mb-2"
      dense
      fixed-header
      hide-default-footer
      :headers="rainHeaders"
      :items="rainItems"
      :items-per-page="-1"
      @click:row="moveObservatoryDetail"
    >
    </v-data-table>

    <!-- マンホール -->
    <v-card tile flat height="35">
      <v-chip small>
        <v-switch dense v-model="visiblity.manhole"></v-switch>
        マンホールモニタリング
      </v-chip>
    </v-card>
    <v-data-table
      v-if="visiblity.manhole"
      :height="tableHeight.manhole"
      class="manhole-table mb-2"
      dense
      fixed-header
      hide-default-footer
      :headers="manholeHeaders"
      :items="manholeItems"
      :items-per-page="-1"
      @click:row="moveObservatoryDetail"
    >
      <template v-slot:[`item.level`]="{ item }">
        <div>
          {{
            item.is_mentenance === true || item.level === undefined
              ? "-"
              : item.level.toFixed(2)
          }}
        </div>
      </template>
      <template v-slot:[`item.graph`]="{ item }">
        <div class="graph-area">
          <v-progress-linear
            v-model="item.graph.levelProportion"
            color="#3388ff"
            height="18"
          ></v-progress-linear>
          <div
            class="level-line alert1"
            :style="{ left: item.graph.alert1 + '%' }"
          ></div>
          <div
            class="level-line alert2"
            :style="{ left: item.graph.alert2 + '%' }"
          ></div>
        </div>
      </template>
    </v-data-table>

    <!-- 水位 -->
    <v-card tile flat height="35">
      <v-chip small>
        <v-switch dense v-model="visiblity.stage"></v-switch>
        水位モニタリング
      </v-chip>
    </v-card>
    <v-data-table
      v-if="visiblity.stage"
      :height="tableHeight.stage"
      class="stage-table"
      dense
      fixed-header
      hide-default-footer
      :headers="stageHeaders"
      :items="stageItems"
      :items-per-page="-1"
      @click:row="moveObservatoryDetail"
    >
      <template v-slot:[`item.graph`]="{ item }">
        <div class="graph-area">
          <v-progress-linear
            v-model="item.graph.levelProportion"
            color="#3388ff"
            height="18"
          ></v-progress-linear>
          <div
            v-if="item.graph.dangerous !== null"
            class="level-line dangerous-color"
            :style="{ left: item.graph.dangerous + '%' }"
          ></div>
        </div>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import L from "leaflet";
import _ from "lodash";
import { OBSERVATORY } from "../enums/Type";

export default {
  name: "Monitoring",
  components: {},
  data() {
    return {
      visiblity: {
        rain: true,
        manhole: true,
        stage: false
      },
      rainHeaders: [
        {
          text: "観測所",
          align: "left",
          sortable: false,
          value: "name",
          class: "data-table-header"
        },
        {
          text: "現在雨量",
          align: "right",
          sortable: false,
          value: "min10",
          width: "80px",
          class: "data-table-header"
        },
        {
          text: "累加雨量",
          align: "right",
          sortable: false,
          value: "total",
          width: "80px",
          class: "data-table-header"
        }
      ],
      manholeHeaders: [
        {
          text: "観測所",
          align: "left",
          sortable: false,
          value: "name",
          class: "data-table-header"
        },
        {
          text: "水位",
          align: "right",
          sortable: false,
          value: "level",
          width: "70px",
          class: "data-table-header"
        },
        {
          text: "グラフ",
          sortable: false,
          value: "graph",
          width: "100px",
          class: "data-table-header"
        }
      ],
      stageHeaders: [
        {
          text: "観測所",
          align: "left",
          sortable: false,
          value: "name",
          width: "100px",
          class: "data-table-header"
        },
        {
          text: "氾濫\n注意",
          align: "right",
          sortable: false,
          value: "warning",
          width: "40px",
          class: "data-table-header warning-color"
        },
        {
          text: "避難\n判断",
          align: "right",
          sortable: false,
          value: "evacuation",
          width: "40px",
          class: "data-table-header evacuation-color"
        },
        {
          text: "氾濫\n危険",
          align: "right",
          sortable: false,
          value: "dangerous",
          width: "40px",
          class: "data-table-header dangerous-color"
        },
        {
          text: "氾濫\n発生",
          align: "right",
          sortable: false,
          value: "outbreak",
          width: "40px",
          class: "data-table-header outbreak-color"
        },
        {
          text: "現在\n水位",
          align: "right",
          sortable: false,
          value: "level",
          width: "40px",
          class: "data-table-header"
        },
        {
          text: "グラフ",
          sortable: false,
          value: "graph",
          width: "60px",
          class: "data-table-header"
        }
      ]
    };
  },

  computed: {
    leafletMap() {
      return this.$store.getters.leafletMap;
    },
    currentDateTime() {
      const baseDate = this.$store.getters.baseDate.clone();
      baseDate.subtract(baseDate.minute() % 10, "minutes");
      return baseDate.local().format("YYYY/MM/DD HH:mm");
    },
    tableHeight() {
      const hh = "180px";
      const { rain, manhole, stage } = this.visiblity;
      if (rain && manhole && stage) {
        return {
          rain: `calc(35dvh - ${hh} / 3)`,
          manhole: `calc(35dvh - ${hh} / 3)`,
          stage: `calc(30dvh - ${hh} / 3)`
        };
      } else if (
        (rain && manhole && !stage) ||
        (rain && !manhole && stage) ||
        (!rain && manhole && stage)
      ) {
        return {
          rain: `calc(50dvh - ${hh} / 2`,
          manhole: `calc(50dvh - ${hh} / 2)`,
          stage: `calc(50dvh - ${hh} / 2)`
        };
      } else {
        return {
          rain: `calc(100dvh - ${hh})`,
          manhole: `calc(100dvh - ${hh})`,
          stage: `calc(100dvh - ${hh})`
        };
      }
    },
    rainItems() {
      const arr = this.$store.getters.observatories;
      let observatories = arr.filter(
        obs =>
          obs.type === OBSERVATORY.RAIN.code &&
          ([
            "911_1",
            "911_2",
            "21269_4",
            "21269_5",
            "21269_6",
            "3073_20",
            "3073_75",
            "3073_42",
            "3073_76",
            "3073_69"
          ].includes(obs.id) ||
            obs.id.startsWith("99_12217_2_"))
      );
      observatories = observatories.map(obs => {
        const r = Object.assign({}, obs);
        r.sortMin10 = r.min10 === undefined ? -999 : r.min10;
        r.sortTotal = r.total === undefined ? -999 : r.total;
        if (r.min10 === -999) {
          r.min10 = "欠測";
        }
        if (r.total === -999) {
          r.total = "欠測";
        }
        return r;
      });
      return _.orderBy(
        observatories,
        ["sortMin10", "sortTotal"],
        ["desc", "desc"]
      );
    },
    manholeItems() {
      const arr = this.$store.getters.observatories.filter(
        obs => obs.type === OBSERVATORY.MANHOLE.code
      );
      const manholes = JSON.parse(JSON.stringify(arr));
      manholes.forEach(m => {
        let level = m.level === undefined ? 0 : m.level;
        if (m.is_mentenance === true) {
          level = 0;
        }
        let alert1 = 0;
        let alert2 = 0;
        if (m.landform === undefined || m.landform.length === 0) {
          alert2 = level + 5;
        } else {
          const arrY = m.landform.map(lf => lf[1]).filter(y => y > 0);
          const maxY = Math.max(...arrY);
          alert1 = Math.max(...arrY.filter(y => y < maxY));
          alert2 = maxY;
        }
        level = level * 100;
        alert1 = alert1 * 100;
        alert2 = alert2 * 100;
        if (m.warningLevel !== undefined) {
          alert1 = m.warningLevel * 100;
        }
        if (m.dangerousLevel !== undefined) {
          alert2 = m.dangerousLevel * 100;
        }
        const maxVal = Math.max(level, alert1, alert2) * 1.2;
        m.graph = {
          alert1: (alert1 / maxVal) * 100,
          alert2: (alert2 / maxVal) * 100,
          levelProportion: (level / maxVal) * 100
        };
      });
      return manholes;
    },
    stageItems() {
      const arr = this.$store.getters.observatories;
      let observatories = arr.filter(
        obs =>
          obs.type === OBSERVATORY.STAGE.code &&
          [
            "21279_17",
            "21279_60",
            "21259_31",
            "21259_41",
            "21269_42",
            "21269_30",
            "21269_24",
            "21269_11",
            "3073_105",
            "3073_82",
            "3073_43",
            "3073_85"
          ].includes(obs.id)
      );
      observatories = observatories.map(obs => {
        const r = Object.assign({}, obs);
        r.standby =
          r.standbyLevel !== undefined ? r.standbyLevel.toFixed(2) : "・";
        r.warning =
          r.warningLevel !== undefined ? r.warningLevel.toFixed(2) : "・";
        r.evacuation =
          r.evacuationLevel !== undefined ? r.evacuationLevel.toFixed(2) : "・";
        r.dangerous =
          r.dangerousLevel !== undefined ? r.dangerousLevel.toFixed(2) : "・";
        r.outbreak =
          r.outbreakLevel !== undefined ? r.outbreakLevel.toFixed(2) : "・";
        r.level =
          r.level === undefined || r.level === -999
            ? "欠測"
            : r.level.toFixed(2);
        r.sortLevel = r.outbreakLevel || r.dangerousLevel ? 1 : 9;
        if (r.level === "欠測") {
          r.sortLevel = r.sortLevel * 10;
        }
        return r;
      });
      observatories.forEach(r => {
        let graphMaxValue = 0;
        let dangerous =
          r.dangerous !== "・"
            ? parseFloat(r.dangerous)
            : parseFloat(r.outbreak);
        let level = r.level;
        if (dangerous !== "・") {
          graphMaxValue = dangerous * 1.2;
        } else if (level !== "欠測") {
          graphMaxValue = level + 10;
        }
        if (dangerous !== "・" && level !== "欠測" && dangerous > 12) {
          const offset = dangerous - 4;
          dangerous -= offset;
          graphMaxValue = dangerous * 1.2;
          level -= offset;
        }
        if (graphMaxValue === 0) {
          graphMaxValue = 0.1;
        }
        r.graph = {
          dangerous:
            dangerous !== "・" ? (dangerous / graphMaxValue) * 100 : null,
          levelProportion: level === "欠測" ? 0 : (level / graphMaxValue) * 100
        };
        r.riskValue =
          dangerous !== "・" && level !== "欠測" ? level / dangerous : 0;
        if (r.riskValue === 0 && level !== "欠測") {
          r.riskValue = level * 0.000001;
        }
      });
      return _.orderBy(
        observatories,
        ["sortLevel", "riskValue"],
        ["asc", "desc"]
      );
    }
  },

  methods: {
    close() {
      this.$store.commit("SET_IS_MONITORING", false);
    },
    moveObservatoryDetail(info) {
      this.leafletMap.panTo(new L.LatLng(info.lat, info.lng));
      const observatory = Object.assign(info, { isMonitoring: true });
      this.$store.dispatch("FETCH_SELECTED_OBSERVATORY_DATA", observatory);
    }
  }
};
</script>

<style lang="scss">
.monitoring-page {
  min-width: 380px;
  padding: 0 8px;
  border-left: 1px solid #c1c1c1;
  th,
  td {
    height: 24px !important;
    font-weight: normal !important;
  }
  td {
    padding: 0 5px 0 3px !important;
    font-size: 12px !important;
    line-height: 1;
    height: inherit;
  }
  .data-table-header {
    padding: 0 5px 0 3px !important;
    min-width: 60px;
  }
  .theme--light.v-data-table thead tr:last-child th {
    border-bottom: 1px double black !important;
  }
}

.rain-table {
  .data-table-header:nth-child(2) {
    background-color: #3a1e87 !important;
    color: white !important;
  }
  .data-table-header:nth-child(3) {
    background-color: #3a1e87 !important;
    color: white !important;
  }
  .theme--light.v-data-table thead tr th {
    color: black;
  }
  tr td:nth-child(2) {
    border-right: 1px solid #3a1e87;
    border-left: 1px solid #3a1e87;
  }
  tr td:nth-child(3) {
    border-right: 1px solid #3a1e87;
  }
}

.manhole-table {
  th:nth-child(2),
  td:nth-child(2) {
    padding: 0 15px 0 0 !important;
  }
  .graph-area {
    pointer-events: none;
    position: relative;
    .level-line {
      position: absolute;
      top: 0;
      height: 100%;
      &.alert1 {
        background-color: #f89436;
        width: 2px;
      }
      &.alert2 {
        background-color: #ad02ad;
        width: 3px;
      }
    }
  }
}

.stage-table {
  .data-table-header {
    &.standby-color {
      color: #008000 !important;
    }
    &.warning-color {
      color: #ffa500 !important;
    }
    &.evacuation-color {
      color: #ff2800 !important;
    }
    &.dangerous-color {
      color: #ad02ad !important;
    }
    &.outbreak-color {
      color: #000000 !important;
    }
  }
  .theme--light.v-data-table thead tr:last-child th {
    text-align: center !important;
    white-space: pre-wrap;
  }
  .graph-area {
    pointer-events: none;
    position: relative;
    .level-line {
      position: absolute;
      top: 0;
      left: 50%;
      width: 3px;
      height: 100%;
      &.dangerous-color {
        background-color: #ad02ad !important;
      }
    }
  }
}
</style>
